import { createCore, frameworkCorePlugin, ICore, useIdentity } from './core';
import { InstanceData, InstanceDataType } from './data';
import { createHistory, frameworkHistoryPlugin, IHistory } from './history';
import { createOperate, frameworkOperatePlugin, IOperate } from './operate';
import { createStage, frameworkStagePlugin, IStage } from './stage';

export interface IFramework extends ICore {
    stage: IStage;
    operate: IOperate;
    history: IHistory;
}

export class Framework {
    protected identity: string;
    protected framework: IFramework;

    constructor(identity: string) {
        this.identity = identity;
        this.framework = getFramework(identity);
    }
}

function createFramework(identity: string) {
    const instance = InstanceData.getData(identity, InstanceDataType.Framework);
    if (!instance) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const framework = createCore(identity) as any;
        framework.registerPlugins([
            { plugin: frameworkCorePlugin },
            { plugin: frameworkStagePlugin },
            { plugin: frameworkOperatePlugin },
            { plugin: frameworkHistoryPlugin },
        ]);
        framework.stage = createStage(identity);
        framework.operate = createOperate(identity);
        framework.history = createHistory(identity);
        InstanceData.setData(identity, InstanceDataType.Framework, framework);
    }
}

export const useFramework = () => {
    const identity = useIdentity();
    return getFramework(identity);
};

export const getFramework = (identity: string): IFramework => {
    const instance = InstanceData.getData(identity, InstanceDataType.Framework);
    if (!instance) {
        createFramework(identity);
    }
    return InstanceData.getData(identity, InstanceDataType.Framework);
};

export function delFramework(identity: string) {
    setTimeout(() => {
        // 延迟删除，避免在销毁时，其他地方还在使用
        InstanceData.delInstance(identity);
    }, 100);
}
